module.exports = __webpack_public_path__ + "static/media/logo-blue.74824f43.svg";